// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2MJPe","productName":"Table_productName__ZrlKR"};